import { CommonModule } from '@angular/common';
import { Component, signal, WritableSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import { TableFilterComponentModel } from './table-filter-component.model';
import { MatButtonModule } from '@angular/material/button';
import { TableFilterService } from './table-filter.service';
import { TranslocoService } from '@ngneat/transloco';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'lib-table-filter-component',
    imports: [CommonModule, FormlyModule, ReactiveFormsModule, MatButtonModule],
    templateUrl: './table-filter-component.component.html',
    styleUrl: './table-filter-component.component.css',
})
export class TableFilterComponentComponent extends DialogBuilderComponent<TableFilterComponentModel> {
    form: FormGroup = new FormGroup({});
    fields: WritableSignal<FormlyFieldConfig[]> = signal([]);
    _translocoContent: any;

    constructor(
        private filterService: TableFilterService,
        private translate: TranslocoService
    ) {
        super();
        this._translocoContent = toSignal(translate.selectTranslation());

        this.form.valueChanges.subscribe(() => {
            this.filterService.model.filters[this.componentModel.key] =
                this.form.value.selectedValues;
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.componentModel.selectedValues =
            this.filterService.model.filters[this.componentModel.key];
        this.setupFields();
    }

    resetCheckboxes() {
        // Get the current 'selectedValues' object from the form control
        const selectedValues = this.form.controls['selectedValues'].value;

        // Loop through each property in the selectedValues object and set it to false
        const resetValues = Object.keys(selectedValues).reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {});

        // Set the new 'selectedValues' object with all values set to false
        this.form.controls['selectedValues'].setValue(resetValues);
    }

    private setupFields(): void {
        this.fields.set([
            {
                className: 'flex flex-col w-full overflow-auto max-h-10',
                fieldGroupClassName: 'flex flex-col w-full overflow-auto max-h-10',
                key: 'selectedValues',
                type: 'multicheckbox',
                templateOptions: {
                    options: Object.keys(this.componentModel.selectedValues).map((value: any) => {
                        return {
                            label: value,
                            value: value,
                        };
                    }),
                },
            },
        ]);
    }
}
